import React, { forwardRef } from 'react';
import ReCAPTCHA3P from 'react-google-recaptcha';
const ReCaptcha = (props, ref) => (React.createElement(ReCAPTCHA3P, Object.assign({ ref: ref }, props)));
const ReCaptchaFRC = forwardRef(ReCaptcha);
ReCaptchaFRC.displayName = 'ReCaptchaFRC';
export default ReCaptchaFRC;
